import { logger } from 'services';
import { exponentialRetryForImport } from 'utils/lazyWithRetry';

const getSoundFactory = (): (() => [() => any]) => {
  // eslint-disable-next-line prefer-const
  let sound: [() => any] = [() => {}];
  const _getSound = () => {
    return sound;
  };

  const setAudio = () =>
    import('./error1.ogg')
      .then((res) => {
        const audio = new Audio(res.default);

        sound[0] = () => audio.play();
      })
      .catch((e) => {
        logger.log('failed to fetch audio retrying');
        throw e;
      });

  exponentialRetryForImport(setAudio);

  return _getSound;
};

export const useErrorSound = getSoundFactory();
